import React, { useState, useEffect, memo } from 'react'

// nodejs library to set properties for components
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux'
import { ServerConfig } from 'config'
import axios from 'axios'
import { hasPermission } from 'utils/hasPermission';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'
import { Typography, Grid, Hidden, Container } from '@material-ui/core'
import { ListGroup, ListGroupItem } from 'reactstrap';
import { AppBar, Tabs, Tab } from '@material-ui/core';
import Box from "@material-ui/core/Box";

// components
import Page from 'components/Page/Page'
import _, { get } from 'lodash'

import Customers from './Customers.js'
import Logs from './Logs.js'
import Machines from './Machines.js'
import Employees from './Employees.js'
import Tenants from './Tenants.js'
import TenantSites from './TenantSites.js'
import Ecocontrols from "./Ecocontrols";
import TenantCashdrawers from "./TenantCashdrawers.js";
import TenantPrinters from "./TenantPrinters.js";
import TenantEmployees from './TenantEmployees.js'
import RefundRates from './RefundRates.js'
import IFSStats from './IFSStats.js'
//import BagStickerMap from './BagStickerMap.js'
import BagsAndTokens from './BagsAndTokens.js'
import Ecosacks from './Ecosacks.js'
import LogoPolicies from './LogoPolicies.js'
import AtmDevices from './AtmDevices.js'
import ResetTenantTrainingTransactions from './ResetTenantTrainingTransactions.js'

const useStyles = makeStyles((theme) => ({ }))

const AdminPage = ({ children }) => {
  const auth = useSelector(state => state.auth)
  const classes = useStyles()

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div {...other}>
        {value === index && <Box p={3}>{children}</Box>}
      </div>
    );
  }

  if (!auth.access_token) {
    return <Redirect to="/login" />
  }

  const isAdmin = hasPermission(auth.permissions, ['Admin', 'admin']);

  if (!isAdmin) {
    // You can also render a "no permission" message instead of redirect
    return <Redirect to="/" />;
  }

  return (
    <Page title="Admin">
      <Container maxWidth={false}>

        <AppBar position="static">
          <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" variant="scrollable">
            <Tab label="Customers" />
            <Tab label="Logs" />
            {/* <Tab label="IFSStats" /> */}
            <Tab label="Machines" />
            <Tab label="Employees" />
            <Tab label="Tenants" />
            <Tab label="Sites" />
            <Tab label="Ecocontrols" />
            <Tab label="Cashdrawers" />
            <Tab label="Printers" />
            <Tab label="Employees" />
            <Tab label="Bags & Tokens" />
            <Tab label="RefundRates" />
            <Tab label="Ecosacks"/>
            <Tab label="Logo Policies"/>
            <Tab label="ATM Devices"/>
            <Tab label="Reset Training Txns"/>
          </Tabs>
        </AppBar>

        <TabPanel value={value} index={0}>
            <Customers />
        </TabPanel>

        <TabPanel value={value} index={1}>
            <Logs />
        </TabPanel>

        {/*<TabPanel value={value} index={2}>
            <IFSStats />
        </TabPanel>*/}


        <TabPanel value={value} index={2}>
            <Machines />
        </TabPanel>

        <TabPanel value={value} index={3}>
            <Employees />
        </TabPanel>

        <TabPanel value={value} index={4}>
            <Tenants />
        </TabPanel>

        <TabPanel value={value} index={5}>
            <TenantSites />
        </TabPanel>

        <TabPanel value={value} index={6}>
            <Ecocontrols />
        </TabPanel>

        <TabPanel value={value} index={7}>
            <TenantCashdrawers />
        </TabPanel>

        <TabPanel value={value} index={8}>
            <TenantPrinters />
        </TabPanel>

        <TabPanel value={value} index={9}>
            <TenantEmployees />
        </TabPanel>

        <TabPanel value={value} index={10}>
            <BagsAndTokens />
        </TabPanel>

        <TabPanel value={value} index={11}>
            <RefundRates />
        </TabPanel>

        <TabPanel value={value} index={12}>
            <Ecosacks />
        </TabPanel>

        <TabPanel value={value} index={13}>
            <LogoPolicies />
        </TabPanel>

        <TabPanel value={value} index={14}>
            <AtmDevices />
        </TabPanel>

        <TabPanel value={value} index={15}>
            <ResetTenantTrainingTransactions />
        </TabPanel>

      </Container>
    </Page>
  )
}

export default AdminPage

AdminPage.propTypes = {
  children: PropTypes.node
}
